/**
 * Card Reader RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import {
  GetCardsRequestSchema,
  GetCardsResponseSchema,
  GetPatientFromCardRequestSchema,
  GetPatientFromCardResponseSchema,
  GetPatientFromTerminalRequestSchema,
  GetPatientFromTerminalResponseSchema,
  ApplyActionRequestSchema,
  ApplyActionResponseSchema,
  GetTiRequestSchema,
  GetTiResponseSchema,
  GetTiSettingsResponseSchema,
} from "../schemas/cardreader/index";
import {
  ExternalAPIErrorSchema,
  NotFoundErrorSchema,
  TerminalNotFoundErrorSchema,
} from "../errors";

const EmptyRequest = Schema.Struct({});

export class CardReaderRpcs extends RpcGroup.make(
  Rpc.make("CardReaderGetCards", {
    success: GetCardsResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, TerminalNotFoundErrorSchema]),
    payload: GetCardsRequestSchema,
  }),
  Rpc.make("CardReaderGetPatientFromCard", {
    success: GetPatientFromCardResponseSchema,
    error: ExternalAPIErrorSchema,
    payload: GetPatientFromCardRequestSchema,
  }),
  Rpc.make("CardReaderGetPatientFromTerminal", {
    success: GetPatientFromTerminalResponseSchema,
    error: Schema.Union(
      [ExternalAPIErrorSchema,
      NotFoundErrorSchema,
      TerminalNotFoundErrorSchema]
    ),
    payload: GetPatientFromTerminalRequestSchema,
  }),
  Rpc.make("CardReaderApplyAction", {
    success: ApplyActionResponseSchema,
    error: ExternalAPIErrorSchema,
    payload: ApplyActionRequestSchema,
  }),
  Rpc.make("CardReaderGetTi", {
    success: GetTiResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: GetTiRequestSchema,
  }),
  Rpc.make("CardReaderGetTiSettings", {
    success: GetTiSettingsResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: EmptyRequest,
  })
) {}
